<!-- @format -->

@if (!isLoadingData) {
  <div class="nav-bar">
    <a [routerLink]='["/timesheet"]' [class.active]='isCurrentActiveRoute("/timesheet")'>Timesheet</a>
    <a [routerLink]='["/year-at-a-glance"]' [class.active]='isCurrentActiveRoute("/year-at-a-glance")'>Year at a Glance</a>
    @if (isManager()) {
      <a [routerLink]='["/approvals"]' [class.active]='isCurrentActiveRoute("/approvals")'>Approvals</a>
    }
    @if (isManagerOrTimeKeeper()) {
      <a [routerLink]='["/team"]' [class.active]='isCurrentActiveRoute("/team")'>Team</a>
    }
    @if (isManagerOrTimeKeeper()) {
      <a [routerLink]='["/delegations"]' [class.active]='isCurrentActiveRoute("/delegations")'>Delegations</a>
    }
    @if (isManagerOrTimeKeeper()) {
      <a [routerLink]='["/acting-scheduler"]' [class.active]="isCurrentActiveRoute('/acting-scheduler')"
        >Acting Scheduler</a
        >
      }
      @if (isManagerOrTimeKeeper()) {
        <a [routerLink]='["/posting"]' [class.active]='isCurrentActiveRoute("/posting")'>Posting</a>
      }
      @if (isManagerOrTimeKeeper()) {
        <a [routerLink]='["/email-scheduler"]' [class.active]='isCurrentActiveRoute("/email-scheduler")'
          >Email Scheduler</a
          >
        }
      </div>
    }
    <div class="nav-border-bottom"></div>
